import React from 'react';
import { Toaster, resolveValue, ToastBar, toast } from 'react-hot-toast';
import { CheckCircle2, AlertCircle, Info, Loader2, X } from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';

export function CustomToaster() {
  return (
    <Toaster 
      position="top-right" 
      toastOptions={{
        duration: 5000,
      }}
      containerStyle={{ zIndex: 99999999 }}
      containerClassName="z-[99999999]"
    >
      {(t) => {
        const isError = t.type === 'error';
        const isSuccess = t.type === 'success';
        const isLoading = t.type === 'loading';

        return (
          <motion.div
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: t.visible ? 1 : 0, y: t.visible ? 0 : -20, scale: t.visible ? 1 : 0.95 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
            className={`flex items-start gap-3 w-max min-w-[300px] sm:max-w-md max-w-[calc(100vw-2rem)] p-4 rounded-xl dark:shadow-lg border backdrop-blur-md ${
              isError 
                ? 'bg-rose-500/10 border-rose-500/20 text-rose-700 dark:text-rose-300 dark:bg-rose-500/10 dark:border-rose-500/20' 
                : isSuccess
                ? 'bg-emerald-500/10 border-emerald-500/20 text-emerald-700 dark:text-emerald-300 dark:bg-emerald-500/10 dark:border-emerald-500/20'
                : 'bg-white/80 border-slate-200 text-slate-700 dark:bg-slate-900/80 dark:border-slate-800 dark:text-slate-300'
            }`}
          >
            <div className="shrink-0 mt-0.5">
              {isError && <AlertCircle className="w-5 h-5 text-rose-600 dark:text-rose-400" />}
              {isSuccess && <CheckCircle2 className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />}
              {isLoading && <Loader2 className="w-5 h-5 animate-spin text-blue-600 dark:text-blue-400" />}
              {!isError && !isSuccess && !isLoading && <Info className="w-5 h-5 text-slate-500 dark:text-slate-400" />}
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium leading-relaxed">
                {resolveValue(t.message, t)}
              </p>
            </div>

            <button
              onClick={() => toast.dismiss(t.id)}
              className="shrink-0 p-1 rounded-md hover:bg-black/5 dark:hover:bg-white/5 transition-colors focus:outline-none cursor-pointer"
            >
              <X className={`w-4 h-4 ${
                isError ? 'text-rose-600/70 hover:text-rose-600 dark:text-rose-400/70 dark:hover:text-rose-400'
                : isSuccess ? 'text-emerald-600/70 hover:text-emerald-600 dark:text-emerald-400/70 dark:hover:text-emerald-400'
                : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
              }`} />
            </button>
          </motion.div>
        );
      }}
    </Toaster>
  );
}
